'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/api.png'
import { Helmet } from 'react-helmet';



const ReliableMain = () => {
    // State to hold dynamic content
    const [serviceDetails] = useState({
        title: "API Security",
        text1: "API (Application Programming Interface) security is crucial for protecting data and ensuring the integrity of interactions between applications and services. Here’s a structured approach to creating content and basic steps for API security:",
        image1: ServiceDetailsImg,
        
        text2: (
            <>
                <b>Common API Threats:</b><br />
                Unauthorized Access: Gaining access without proper credentials.<br />
                Injection Attacks: Malicious code injected into API requests.<br />
                Data Exposure: Unintended leakage of sensitive information.<br />
                <br />
                <b>Best Practices for API Security:</b><br />
                Use strong authentication and authorization protocols.<br />
                Encrypt data in transit to prevent unauthorized access.<br />
                Rate limit API usage to prevent abuse.<br />
                Securely manage and rotate API keys.<br />
                <br />
            </>
        ),
        features: [
            {
                icon: "icon-crane-1",
                title: "Reliable Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
            {
                icon: "icon-buildings",
                title: "Building Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
        ],
    });

    return (
        <React.Fragment>
            <Helmet>
		     <title>API Security - techtotalers</title>
	        </Helmet>
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div>
                                </div>
                                <div className="service-details__content-two">
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                <h4 className="service-details__sidebar-title">Main Service</h4>
                                <ul className="service-details__service-list list-unstyled">
                                    <li>
                                    <Link to="/security-consulting">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Security Consulting
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/audit-&-compliance">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Audit & Compliance
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/cloud-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Cloud Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/network-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Network Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/design-&-implementation">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Design & Implementation
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/managed-it-services">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Managed IT Services
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/ot-iot-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        OT, IoT Security
                                    </Link>
                                    </li>
                                    <li className="active">
                                    <Link to="/api-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        API Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/offensive-security-red-teaming">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Offensive Security, Red Teaming
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/vulnerability-assessment">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Vulnerability Assessment
                                    </Link>
                                    </li>                                                               </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default ReliableMain;
